// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: 6absOovmls

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import Button from "../../Button"; // plasmic-import: JUDb72ncw4_/component

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicSectionSettingsSourcePanel.module.css"; // plasmic-import: 6absOovmls/css

import ChecksvgIcon from "./icons/PlasmicIcon__Checksvg"; // plasmic-import: -JcA6DjnTkO/icon
import OpensvgIcon from "./icons/PlasmicIcon__Opensvg"; // plasmic-import: kwHep2tLbo/icon

createPlasmicElementProxy;

export type PlasmicSectionSettingsSourcePanel__VariantMembers = {
  showButtonPanel: "showButtonPanel";
};
export type PlasmicSectionSettingsSourcePanel__VariantsArgs = {
  showButtonPanel?: SingleBooleanChoiceArg<"showButtonPanel">;
};
type VariantPropType = keyof PlasmicSectionSettingsSourcePanel__VariantsArgs;
export const PlasmicSectionSettingsSourcePanel__VariantProps =
  new Array<VariantPropType>("showButtonPanel");

export type PlasmicSectionSettingsSourcePanel__ArgsType = {
  sourcePanelContent?: React.ReactNode;
};
type ArgPropType = keyof PlasmicSectionSettingsSourcePanel__ArgsType;
export const PlasmicSectionSettingsSourcePanel__ArgProps =
  new Array<ArgPropType>("sourcePanelContent");

export type PlasmicSectionSettingsSourcePanel__OverridesType = {
  root?: p.Flex<"div">;
  sourcePanel?: p.Flex<"div">;
  buttonPanel?: p.Flex<"div">;
  freeBox?: p.Flex<"div">;
  showMoreSourcesButton?: p.Flex<typeof Button>;
  text?: p.Flex<"div">;
  svg?: p.Flex<"svg">;
};

export interface DefaultSectionSettingsSourcePanelProps {
  sourcePanelContent?: React.ReactNode;
  showButtonPanel?: SingleBooleanChoiceArg<"showButtonPanel">;
  className?: string;
}

const $$ = {};

function PlasmicSectionSettingsSourcePanel__RenderFunc(props: {
  variants: PlasmicSectionSettingsSourcePanel__VariantsArgs;
  args: PlasmicSectionSettingsSourcePanel__ArgsType;
  overrides: PlasmicSectionSettingsSourcePanel__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "showButtonPanel",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.showButtonPanel
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root
      )}
    >
      <p.Stack
        as={"div"}
        data-plasmic-name={"sourcePanel"}
        data-plasmic-override={overrides.sourcePanel}
        hasGap={true}
        className={classNames(projectcss.all, sty.sourcePanel)}
      >
        {p.renderPlasmicSlot({
          defaultContents: null,
          value: args.sourcePanelContent
        })}
      </p.Stack>
      <div
        data-plasmic-name={"buttonPanel"}
        data-plasmic-override={overrides.buttonPanel}
        className={classNames(projectcss.all, sty.buttonPanel, {
          [sty.buttonPanelshowButtonPanel]: hasVariant(
            $state,
            "showButtonPanel",
            "showButtonPanel"
          )
        })}
      >
        <div
          data-plasmic-name={"freeBox"}
          data-plasmic-override={overrides.freeBox}
          className={classNames(projectcss.all, sty.freeBox)}
        >
          <Button
            data-plasmic-name={"showMoreSourcesButton"}
            data-plasmic-override={overrides.showMoreSourcesButton}
            className={classNames("__wab_instance", sty.showMoreSourcesButton)}
            color={"lightBlue"}
            dropshadow={"basic"}
            endIcon={
              <OpensvgIcon
                data-plasmic-name={"svg"}
                data-plasmic-override={overrides.svg}
                className={classNames(projectcss.all, sty.svg)}
                role={"img"}
              />
            }
            shape={"rounded"}
            size={"minimal"}
            submitsForm={true}
          >
            <div
              data-plasmic-name={"text"}
              data-plasmic-override={overrides.text}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text
              )}
            >
              {"show more Sources  \u21a7"}
            </div>
          </Button>
        </div>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "sourcePanel",
    "buttonPanel",
    "freeBox",
    "showMoreSourcesButton",
    "text",
    "svg"
  ],
  sourcePanel: ["sourcePanel"],
  buttonPanel: [
    "buttonPanel",
    "freeBox",
    "showMoreSourcesButton",
    "text",
    "svg"
  ],
  freeBox: ["freeBox", "showMoreSourcesButton", "text", "svg"],
  showMoreSourcesButton: ["showMoreSourcesButton", "text", "svg"],
  text: ["text"],
  svg: ["svg"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  sourcePanel: "div";
  buttonPanel: "div";
  freeBox: "div";
  showMoreSourcesButton: typeof Button;
  text: "div";
  svg: "svg";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicSectionSettingsSourcePanel__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicSectionSettingsSourcePanel__VariantsArgs;
    args?: PlasmicSectionSettingsSourcePanel__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicSectionSettingsSourcePanel__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicSectionSettingsSourcePanel__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSectionSettingsSourcePanel__ArgProps,
          internalVariantPropNames:
            PlasmicSectionSettingsSourcePanel__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSectionSettingsSourcePanel__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicSectionSettingsSourcePanel";
  } else {
    func.displayName = `PlasmicSectionSettingsSourcePanel.${nodeName}`;
  }
  return func;
}

export const PlasmicSectionSettingsSourcePanel = Object.assign(
  // Top-level PlasmicSectionSettingsSourcePanel renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    sourcePanel: makeNodeComponent("sourcePanel"),
    buttonPanel: makeNodeComponent("buttonPanel"),
    freeBox: makeNodeComponent("freeBox"),
    showMoreSourcesButton: makeNodeComponent("showMoreSourcesButton"),
    text: makeNodeComponent("text"),
    svg: makeNodeComponent("svg"),

    // Metadata about props expected for PlasmicSectionSettingsSourcePanel
    internalVariantProps: PlasmicSectionSettingsSourcePanel__VariantProps,
    internalArgProps: PlasmicSectionSettingsSourcePanel__ArgProps
  }
);

export default PlasmicSectionSettingsSourcePanel;
/* prettier-ignore-end */
